// const BACKEND_BASE_URL="http://127.0.0.1:8000"
const BACKEND_BASE_URL="https://b.innovicloud.com"
const YOUTUBE_API_KEY="AIzaSyCm-yCYmB0Bb1Wg1b6m5SfbL5Hdi-Vto9w"
const FRONTEND_URL="https://a.innovicloud.com/app/manage"
const CAPTURE_BACKEND_URL="http://20.246.111.67:8001"
export  {BACKEND_BASE_URL, YOUTUBE_API_KEY, FRONTEND_URL, CAPTURE_BACKEND_URL};
